import { render, staticRenderFns } from "./register_success.vue?vue&type=template&id=04a09be6&scoped=true"
import script from "./register_success.vue?vue&type=script&lang=js"
export * from "./register_success.vue?vue&type=script&lang=js"
import style0 from "./register_success.vue?vue&type=style&index=0&id=04a09be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a09be6",
  null
  
)

export default component.exports